export default "__VITE_ASSET__DmWDSv2z__"